<template>
  <div v-if="loading" class="flex h-full justify-center items-center">
    <loading-spinner diameter="64px" />
  </div>

  <alert-badge
    v-else-if="error.title"
    isDanger
    :title="error.title"
    :body="error.body"
    @dismissed="
      () => {
        error.title = ''
        error.body = ''
      }
    "
  />

  <customer-form
    v-else
    :initCustomer="initCustomer"
    :successMsg="$t('actions.saveChangesSuccess')"
    :submitAction="update"
  />
</template>

<script lang="ts">
import { defineComponent, onBeforeMount, ref } from 'vue'

import { useHTTP } from '@/plugins/http'

import Customer from '@/models/customer/Customer'

// components
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import CustomerForm from '@/views/customers/CustomerForm.vue'
import AlertBadge from '@/components/AlertBadge.vue'
import { useRoute, useRouter } from 'vue-router'

export default defineComponent({
  name: 'customer',
  components: {
    LoadingSpinner,
    CustomerForm,
    AlertBadge
  },
  setup() {
    const initCustomer = ref(new Customer())
    const error = ref({ title: '', body: '' })
    const http = useHTTP()
    const loading = ref(true)
    const route = useRoute()
    const router = useRouter()

    onBeforeMount(async () => {
      const url = `${Customer.ENDPOINT}/${route.params.id}`

      try {
        const resp = await http.get<Customer>(url)
        initCustomer.value = Customer.from(resp)
      } catch (errorResp) {
        error.value.title = errorResp.title
        error.value.body = errorResp.body
      }

      loading.value = false
    })

    const update = async (customer: Customer) => {
      try {
        const url = `${Customer.ENDPOINT}/${customer.id}`
        const resp = await http.put<Customer>(url, customer)
        initCustomer.value = Customer.from(resp)
        router.back()
      } catch (error) {
        return error
      }
    }

    return {
      initCustomer,
      error,
      loading,
      update
    }
  }
})
</script>
